import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { useDropzone } from 'react-dropzone';
import { Button, Modal, Row, Col, FormGroup, FormText, ModalBody, ModalFooter, Label, Input } from 'reactstrap';
import { addNewLibrary } from './redux/dispatcher';

function AddLibrary({ modal, toggle }) {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file && file.type === 'application/pdf') {
            setFile(file);
        } else {
            setFile(null);
            toast.error('Please select a valid PDF file.');
        }
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'application/pdf',
        multiple: false
    });

    const handleFileUpload = (e) => {
        e.preventDefault();

        if (!fileName) {
            toast.error('Please enter library name.');
            return;
        }

        if (file) {
            const formData = new FormData();
            formData.append('file_name', fileName);
            formData.append('file_path', file);
            dispatch(addNewLibrary(formData, toggle));
        } else {
            toast.error('Please select a valid PDF file.');
        }
    };

    return (
        <div>
            <Button color="primary" onClick={toggle}>
                <i className="fa-solid fa-cloud-arrow-up"></i> Add New File
            </Button>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label for="libraryName">
                                    File Name <span style={{ color: 'red' }}>*</span> (Should be unique)
                                </Label>

                                <Input
                                    id="libraryName"
                                    name="libraryName"
                                    placeholder="File Name"
                                    type="text"
                                    value={fileName}
                                    onChange={(e) => setFileName(e.target.value)}
                                    maxLength={50}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup className='text-center'>
                                <div {...getRootProps({ className: 'dropzone' })} style={{ border: '2px dashed grey', padding: '20px', cursor: 'pointer' }}>

                                    <input {...getInputProps()} />
                                    {file ? (
                                        <p>{file.name}</p>
                                    ) : (
                                        <>
                                            <p>Drag & Drop to Upload File </p>
                                            <p>OR </p>
                                        </>
                                    )}
                                    <Button style={{ color: 'white' }} className="btn-primary mb-3">
                                        Browse File</Button>
                                </div>
                                {file && <FormText color="muted">{file.name}</FormText>}
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleFileUpload}>
                        Add
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default AddLibrary;
